import styled from 'styled-components';
import { Flex, type FlexProps } from '../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'InputTextButton' })
    .attrs<FlexProps>({
        direction: 'row',
        alignItems: 'center',
        borderRadius: 2,
        pl: 2,
        pr: 0.5,
        height: 38,
        background: 'var(--control-secondary-background)',
    })``;
